import { z } from 'zod';
const withdrawVolunteersParamsSchema = z.object({
    shiftId: z.string().uuid(),
    shiftParticipations: z
        .object({
        shiftParticipantId: z.string().uuid(),
        shiftParticipationId: z.string().uuid(),
        positionId: z.string().uuid().optional(),
    })
        .array(),
});
export const withdrawVolunteersFunctionDef = {
    name: 'withdrawVolunteers',
    requestSchema: withdrawVolunteersParamsSchema,
    responseSchema: z.void(),
};
